import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ErrorMessage } from '@espacePro/components/_common/Form';
import Btn from '../../main-app/components/buttons/Btn';
import { ToolbarButton } from './ToolbarButton';
import { FONT_FAMILY_MAIN } from '../../main-app/theme';

const Container = styled.div`
flex: 1;
width: 100%;
`;

const MesureCorrectiveBoxTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.44;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 16px;
`;

const MesureCorrectiveBoxField = styled.textarea`
  width: 100%;
  resize: vertical;
  margin-bottom: 18px;
  padding: 14px 16px 5px;
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: #354354;
  outline: none;
  border: 1px solid #cecece;
  border-radius: 2px;
  font-family: ${FONT_FAMILY_MAIN};

  &:focus {
    border: 1px solid #23c4f8;
  }
`;

const MesureCorrectiveBoxFormToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
`;

const MesureCorrectiveBoxButton = styled(Btn)`
  background-color: #4a90e2;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  padding: 12px 24px;
  border: none;
`;

const MesureCorrectiveForm = ({
  value, onChange, onSubmit, isSending, onCancel, hasError,
}) => (
  <Container>
    <MesureCorrectiveBoxTitle>Mesure corrective</MesureCorrectiveBoxTitle>
    <MesureCorrectiveBoxField value={value} onChange={onChange} rows="8" />
    {hasError && <ErrorMessage>Une erreur est survenue, veuillez réessayer</ErrorMessage>}
    <MesureCorrectiveBoxFormToolbar>
      <MesureCorrectiveBoxButton onClick={onSubmit} isLoading={isSending} text="Enregistrer" />
      <ToolbarButton bold onClick={onCancel}>
        Annuler
      </ToolbarButton>
    </MesureCorrectiveBoxFormToolbar>
  </Container>
);

MesureCorrectiveForm.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSending: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

MesureCorrectiveForm.defaultProps = {
  value: '',
  isSending: false,
  hasError: false,
};

export { MesureCorrectiveForm };
